import React, { useContext } from "react";
import { AppContext } from "../context/Context";
import Facebook from "../../svg/Facebook.svg";
import Instagram from "../../svg/Instagram.svg";
import "./Footer.css";

const Footer = () => {
    const { setIsFormOpen } = useContext(AppContext);

    const ComplexItem = ({ name, link }) => {
        return (
            <a href={link} rel="noreferrer" target="_blank">
                {name}
            </a>
        );
    };

    return (
        <footer>
            <div className="inner">
                <div className="container !max-w-full !w-full max-md:!p-0 max-md:!pb-24">
                    <div className="left max-md:!flex-col max-md:!items-start max-md:!gap-24">
                        <img src="/saiahat-logo.svg" alt="logo" />
                        <a target="_blank" rel="noreferrer" href="https://ramsqz.com/ru/home">
                            Корпоративный сайт
                        </a>
                    </div>
                    <div className="right">
                        <div className="top">
                            <div className="addresses">
                                <div className="block">
                                    <h4>Офисы продаж</h4>
                                    <ComplexItem name="г. Алматы, ул. Тимирязева, 37" link="https://go.2gis.com/6m81q" />
                                    <p style={{ fontSize: 14 + "px" }}>
                                        Пн-Пт 10:00-20:00 <br /> Сб-Вс 10:00-19:00
                                    </p>
                                </div>
                                <div className="block">
                                    <h4>Контакты</h4>
                                    <a href="tel: +222" className="phone">
                                        222
                                    </a>
                                    <button onClick={() => setIsFormOpen(true)}>Оставить заявку</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <hr />
                <div className="bottom">
                    <p>
                        Архитектура проекта, изображения благоустройства, фасадов, интерьера, применяемых материалов, их нумерация, инфраструктура комплекса являются условными и
                        могут быть изменены в ходе проектирования, строительства и эксплуатации в рамках положительного заключения государственной экспертизы. Настоящая реклама, в
                        соответствии со ст. 395 ГК РК не является публичной офертой.
                    </p>
                    <div className="bottom-links">
                        <a href="https://www.instagram.com/rams_qazaqstan/">
                            <img src={Instagram} alt="instagram" />
                        </a>
                        <a href="https://www.facebook.com/ramspromokaz/">
                            <img src={Facebook} alt="facebook" />
                        </a>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
